import { RsvpUnitProps } from '../schema/RsvpUnit.types';

export const isEffectivelyActionable = (props: RsvpUnitProps) => {
    const { item, isActionable = true, originalMeetingMessage } = props;

    if (!isActionable) {
        return false;
    }

    if (originalMeetingMessage && !originalMeetingMessage?.AssociatedCalendarItemId) {
        return false;
    }

    if (item?.ResponseType === 'Decline') {
        return false;
    }

    return true;
};
